import { useQuery } from '@tanstack/react-query';
import ApiConfig from 'src/config/api-config';
import { toast } from 'react-hot-toast';

export interface WorkoutData {
  title: string;
  dateLabel: string;
  ymd: string;
  isCompleted: boolean;
  isUpNext: boolean;
  duration: number;
  exercises: any[];
}

export interface WorkoutsTabResponse {
  workouts: WorkoutData[];
  lastWorkoutCompleted: string | null;
  nextScheduledWorkout: string | null;
  backgroundImageGender?: string;
  isDraft?: boolean;
  status?: string;
  generatorType?: string;
  programId?: string;
}

const fetchWorkoutsTab = async (
  clientId: string,
  trainerId?: string,
): Promise<WorkoutsTabResponse> => {
  const queryParams = new URLSearchParams({ clientId });
  if (trainerId) queryParams.append('trainerId', trainerId);

  const apiUrl = `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_GET_CLIENT_WORKOUTS_TAB}?${queryParams.toString()}`;
  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const json = await response.json();
    if (json.status === 'ok') {
      return json.data;
    } else {
      throw new Error(json.error || 'Failed to fetch workouts tab data');
    }
  } catch (error: any) {
    toast.error(error.message || 'Error fetching workouts tab data');
    throw error;
  }
};

export const useGetClientWorkoutsTab = (clientId: string, trainerId?: string) => {
  return useQuery({
    queryKey: ['clientWorkoutsTab', clientId, trainerId],
    queryFn: () => fetchWorkoutsTab(clientId, trainerId),
    enabled: !!clientId,
  });
};
